export const ru = {
    'empty-price': 'Не задана',
    from: 'от',
    to: 'до'
};
